import { Pipe, PipeTransform } from '@angular/core';
import { Beneficiaire } from '../../models/beneficiaire';

@Pipe({
	name: 'filterBeneficiairesByName'
})
export class FilterBeneficiairesByNamePipe implements PipeTransform {
	transform(beneficiaires: Beneficiaire[], filter: string): Beneficiaire[] {
		if (beneficiaires === null || filter === '') {
			return beneficiaires;
		}

		return beneficiaires.filter((beneficiaire) => {
			return (
				(beneficiaire.firstName !== null &&
					beneficiaire.firstName
						.toLowerCase()
						.includes(filter.toLowerCase())) ||
				(beneficiaire.lastName !== null &&
					beneficiaire.lastName.toLowerCase().includes(filter.toLowerCase()))
			);
		});
	}
}
